<div
  class="d-flex align-items-center justify-content-center"
  [style.height]="getTopHeader()"
  [ngClass]="
    serviceOperator
      ? 'unicorn-difficult-quota-service-outer-1'
      : 'unicorn-difficult-quota-outer-1'
  "
>
  <div
    class="py-2 difficult-quotas d-flex align-items-center justify-content-center"
    [ngClass]="getQuotaStatusClass()"
  >
    <div class="difficult-quotas-content d-flex">
      <i
        class="fa fa-exclamation-circle error-icon me-2"
        aria-hidden="true"
      ></i>
      <span *ngIf="difficultQuotas.length === 1"
        >{{ getCombinationOfqualification(difficultQuotas[0].criteria) }} may be
        a difficult quota to field. Adjusting quotas or targeting to broaden the
        search can improve fielding.</span
      >
      <span *ngIf="difficultQuotas.length > 1">
        {{ difficultQuotas.length }} highlighted quotas have been flagged as
        difficult quotas to field. We recommend adjusting quota criteria to
        broaden the search to improve fielding.
      </span>
      <button
        class="btn text-center bg-light review-conflict-btn fw-bold"
        (click)="openDifficultQuotaModal()"
      >
        See Difficult Quota(s)
      </button>
    </div>
  </div>
</div>
